module.exports = __webpack_public_path__ + "img/Picture15.165ad152.png";